import { useState } from "react";
import { fileUrl, PLATFORM_STYLE } from "@/lib/api";

const IMG = "https://static.prod-images.emergentagent.com/jobs/6f6dbf2f-6597-4443-ae81-030622ef710b/images/";
const FALLBACK = {
  Steam: `${IMG}a8242e78e7221b6d80b89b6befcdefbf8d9c31aefd81774e7e6c9fd9cec53315.jpeg`,
  Xbox: `${IMG}a8242e78e7221b6d80b89b6befcdefbf8d9c31aefd81774e7e6c9fd9cec53315.jpeg`,
  Rockstar: `${IMG}f7c5667cbab028585eae6bb7e22ce3b3e8611f19227f055c699417f2a0b28dd7.jpeg`,
  Epic: `${IMG}24e1bc34dbdcfa92e8ee663fafd9fa4492924c1ca5a0480e8e73791c0c9d0f23.jpeg`,
  PlayStation: `${IMG}19ea1a2aa8681bd1f960a181e04ab8a1b583e4a332bb8db9b76511da736b3bce.jpeg`,
  "Battle.net": `${IMG}c9717e17a8f046fa8c1d3c029f563e6fdb3283806069d193f4c996b26902e8b6.jpeg`,
  Other: `${IMG}33e876130b68fdd0d44011a1b8971204285221e4e651bd9bd330ad70f292e3fd.jpeg`,
};

export const GameCover = ({ game, className = "", compact = false }) => {
  const [failed, setFailed] = useState(false);
  const src = game.image_path ? fileUrl(game.image_path) : game.image_url;
  if (src && !failed) {
    return <img src={src} alt={game.name} loading="lazy" onError={() => setFailed(true)} className={`w-full h-full object-cover ${className}`} />;
  }
  const p = PLATFORM_STYLE[game.platform] || PLATFORM_STYLE.Steam;
  return (
    <div data-testid="game-cover-fallback" className={`w-full h-full relative overflow-hidden ${className}`}>
      <img src={FALLBACK[game.platform] || FALLBACK.Steam} alt={game.name} loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-black/10" />
      <span className="absolute left-4 top-4 h-1 w-10 rounded-full" style={{ background: p.bg === "#1b2838" ? p.fg : p.bg }} />
      {!compact && <span className="absolute left-4 bottom-3 right-4 font-display font-bold text-base sm:text-lg leading-tight tracking-tight text-white line-clamp-2 drop-shadow">{game.name}</span>}
    </div>
  );
};

export const PlatformBadge = ({ platform }) => {
  const p = PLATFORM_STYLE[platform] || PLATFORM_STYLE.Steam;
  return (
    <span className="inline-flex items-center text-[10px] uppercase font-bold tracking-[0.15em] px-2 py-1 rounded" style={{ background: p.bg, color: p.fg }}>
      {platform}
    </span>
  );
};
